import * as ActionTypes from './actionTypes.js';

export default function dashboardReducer(state = {}, action) {
  switch (action.type) {
    case ActionTypes.FETCH_USER_PREFERENCE_DATA:
      return {
        ...state,
        ...{
          userPreference: action.payload.response.userPreference.find(
            p => p.userId.toUpperCase() === action.payload?.userIds?.userId?.toUpperCase()
          ),
          csbdLayOutConfig: action.payload.response.userPreference
            .find(p => p.userId === action.payload?.userIds?.csbdUser)
            .preferences.find(q => q.key === 'layoutConfiguration').value,
          gbdLayOutConfig: action.payload.response.userPreference
            .find(p => p.userId === action.payload?.userIds?.gbdUser)
            .preferences.find(q => q.key === 'layoutConfiguration').value,
        },
      };
    case ActionTypes.UPDATE_USER_PREFERENCE_DATA:
      return {
        ...state,
        userPreference: { ...action.payload?.updateUserPreference },
      };
    case ActionTypes.SHOW_CSBD_DASHBOARD:
      return {
        ...state,
        showCsbdDashboard: action.payload,
      };
    case ActionTypes.SHOW_GBD_DASHBOARD:
      return {
        ...state,
        showMedicareDashboard: action.payload,
      };
    case ActionTypes.SHOW_DEFAULT_DASHBOARD:
      return {
        ...state,
        showDefaultDashboard: action.payload,
      };
    case ActionTypes.GET_RESTRICT_ACCESS_DETAILS:
      return {
        ...state,
        restrictAccessDetails: action.payload,
      };
    default:
      return state;
  }
}
